import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { QuizProvider } from './context/QuizContext';
import LoginPage from './pages/LoginPage';
import EducationPage from './pages/EducationPage';
import QuizPage from './pages/QuizPage';
import MicrosoftLinkTest from './pages/MicrosoftLinkTest';
import ResultsPage from './pages/ResultsPage';
import ChecklistPage from './pages/ChecklistPage';
import AuthCallback from './components/AuthCallback';
import ProtectedRoute from './components/ProtectedRoute';
import AdminDashboard from './pages/AdminDashboard';
import AdminUserDetailPage from './pages/AdminUserDetailPage';
import AdminQuestionsPage from './pages/AdminQuestionsPage';
import AdminConfigPage from './pages/AdminConfigPage';
import ResultPage from './pages/ResultPage';
import ResultDetailPage from './pages/ResultDetailPage';
import NotFoundPage from './pages/NotFoundPage';
import ForbiddenPage from './pages/ForbiddenPage';
import AppShell from './components/layout/AppShell';
import './App.css';

function AppContent() {
  const location = useLocation();
  const hidePaths = ['/', '/auth/callback', '/forbidden'];
  const shouldShowHeader = !hidePaths.includes(location.pathname);
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [location.pathname]);
  return (
    <AppShell showHeader={shouldShowHeader}>
      <Routes>
          <Route path="/" element={<LoginPage />} />
          <Route path="/auth/callback" element={<AuthCallback />} />
          <Route path="/education" element={
            <ProtectedRoute>
              <EducationPage />
            </ProtectedRoute>
          } />
          <Route path="/quiz" element={
            <ProtectedRoute>
              <QuizPage />
            </ProtectedRoute>
          } />
          <Route path="/microsoft-test" element={
            <ProtectedRoute>
              <MicrosoftLinkTest />
            </ProtectedRoute>
          } />
          <Route path="/results" element={
            <ProtectedRoute>
              <ResultsPage />
            </ProtectedRoute>
          } />
          <Route path="/checklist" element={
            <ProtectedRoute>
              <ChecklistPage />
            </ProtectedRoute>
          } />
          <Route path="/result" element={
            <ProtectedRoute>
              <ResultPage />
            </ProtectedRoute>
          } />
          <Route path="/result/:id" element={
            <ProtectedRoute>
              <ResultDetailPage />
            </ProtectedRoute>
          } />
          <Route path="/admin" element={
            <ProtectedRoute>
              <AdminDashboard />
            </ProtectedRoute>
          } />
          <Route path="/admin/questions" element={
            <ProtectedRoute>
              <AdminQuestionsPage />
            </ProtectedRoute>
          } />
          <Route path="/admin/config" element={
            <ProtectedRoute>
              <AdminConfigPage />
            </ProtectedRoute>
          } />
          <Route path="/admin/user/:email" element={
            <ProtectedRoute>
              <AdminUserDetailPage />
            </ProtectedRoute>
          } />
          <Route path="/forbidden" element={<ForbiddenPage />} />
          <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </AppShell>
  );
}

function App() {
  return (
    <QuizProvider>
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </QuizProvider>
  );
}

export default App;
